<template>
    <div class="image-block">
      <h3 class="image-title">{{ title }}</h3>
      <img :src="src" :alt="alt" class="info-image" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'InfoImage',
    props: {
      title: String,
      src: String,
      alt: String
    }
  };
  </script>
  
<style scoped>
.image-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.image-block {
  margin-bottom: 1.5em;
}
  .info-image {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
  }
  </style>
  
